import React from "react";
import {
  Grid,
  Button
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import clsx from "clsx";
import rateConvert from "../../../../../utils/rateConvert";

const DefaultAmounts = ({ items, active, minValue, onChange }) => {
  const classes = useStyles();
  const uniqueItems = React.useMemo(() => {
    const seen = new Set();
    const result = [];
    if (minValue != null) {
      result.push(minValue);
      seen.add(minValue);
    }
    items.forEach(item => {
      if (!seen.has(item)) {
        result.push(item);
        seen.add(item);
      }
    });
    return result;
  }, [items, minValue]);

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {uniqueItems.map((item) => (
          <Grid item key={`amount-${item}`}>
            <Button
              className={clsx({
                [classes.button]: true,
                '--active': Boolean(String(active) === String(item))
              })}
              onClick={() => onChange?.(item)}
            >
              {rateConvert(item, {useSybmol: true})}
            </Button>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "16px"
  },
  button: {
    height: "36px",
    display: "flex",
    padding: "0px 24px",
    minWidth: "initial",
    minHeight: "initial",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #FB7800",
    background: "#FFFFFF0D!important",

    fontSize: 16,
    color: "white",
    fontWeight: "500",
    lineHeight: "20px",

    "&.--active": {
      backgroundColor: "#FB7800!important",
    }
  }
}))

export default DefaultAmounts;
